<template lang="pug">
    #companion-home
      //-CompanionNavBar
      .block
          RouterView    
  </template>

<script>
import CompanionNavBar from "@@/Companion/CompanionNavBar";
import AudioPlayer from "@@/Companion/AudioPlayer";

export default {
  name: "CompanionHome",

  components: { CompanionNavBar, AudioPlayer },

  data() {
    return {
      fullPageLoader: false
    };
  },

  computed: {}
};
</script>

<style lang="sass">
#companion-home
  .block
</style>
